import React, { useEffect, useMemo } from 'react';
import './App.css';
import "antd/dist/antd.css";
import { AuthenticateDocument } from './AuthenticateDocument';
import { useState } from 'react';
import MainLayout from './components/MainLayout';
import External from './components/ExternalUser';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setConflictPreviewVerionstate, setIsReadOnly, setIsTemplateDocument } from './app/EditorSlice';
import { hasCachedDocument } from './utils/documentCache';

function App({ isExternal = false, isTemplateDocument = false }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const conflictPreviewVerion = useSelector((state) => state.editor.conflictPreviewVerion);

  // Non-mutating check (safe during render): a renderable cache entry lets us
  // skip the auth-gating loader and render the layout immediately.
  const isDocumentCached = useMemo(
    () => !isTemplateDocument && !conflictPreviewVerion && hasCachedDocument(id),
    [id, isTemplateDocument, conflictPreviewVerion]
  );

  useEffect(() => {
    dispatch(setIsTemplateDocument(isTemplateDocument));

    const searchParams = new URLSearchParams(document.location.search)
    const previewVerion = searchParams.get("versionType");
    if (previewVerion) {
      dispatch(setConflictPreviewVerionstate(previewVerion));
      dispatch(setIsReadOnly(true));
    }
  }, []);


  if (isExternal) {
    return <External />;
  }
  else {
    // Cache hit: render the layout instantly and run auth in the background
    // (no gating loader). Background auth seeds documentInfo from cache, then
    // refreshes it and handles redirects.
    if (isDocumentCached) {
      return (
        <>
          <AuthenticateDocument setIsLoading={setIsAuthenticating} background />
          <MainLayout />
        </>
      );
    }
    if (isAuthenticating && !conflictPreviewVerion) { // isAuthenticating
      return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
    }
    else {
      return <MainLayout />;
    }
  }

}

export default App;
